var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MglVectorLayer',_vm._g(_vm._b({},'MglVectorLayer',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }